"use client";

import { useTranslations } from "next-intl";

import { Title } from "@/shared/components/title";
import { tp } from "@/shared/utils/typograf";
import { Box } from "@/shared/components/box";

import UsdtBrandIcon from "@/shared/icons/usdt-brand.svg";
import BtcBrandIcon from "@/shared/icons/btc-brand.svg";
import EthBrandIcon from "@/shared/icons/eth-brand.svg";
import BankIcon from "@/shared/icons/bank.svg";
import SBPIcon from "@/shared/icons/sbp.svg";
import Image from "next/image";

export const EasyToUse = () => {
  const t = useTranslations("easyToUse");

  return (
    <div
      id="purchase"
      className="easy-to-use-container scroll-mt-20 lg:scroll-mt-28"
    >
      <div className="relative z-20 section-container space-y-8 lg:space-y-12.5">
        <Title className="mx-auto max-w-182 text-center">
          {tp.execute(t("title"))}
        </Title>
        {/* На мобильном способы оплаты идут первыми, описание — под ними. */}
        <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between lg:gap-4">
          <div className="order-2 lg:order-none lg:max-w-135 space-y-4 lg:space-y-6">
            <h5 className="text-2xl leading-8 lg:text-[32px] lg:leading-10 font-medium">
              {tp.execute(t("heading"))}
            </h5>
            <div className="text-[#7B7B87] text-base lg:text-xl space-y-4">
              <p>{tp.execute(t("description1"))}</p>
              <p>{tp.execute(t("description2"))}</p>
            </div>
          </div>
          <div className="order-1 lg:order-none lg:max-w-102 w-full space-y-3 lg:space-y-5">
            <Box className="px-5 lg:px-6 flex items-center justify-between h-16 lg:h-21 rounded-full">
              <p className="text-xl leading-6 lg:text-[28px] lg:leading-8 font-medium">
                {tp.execute(t("paymentMethods.bankTransfer"))}
              </p>
              <BankIcon className="size-9" />
            </Box>
            <Box className="px-5 lg:px-6 flex items-center justify-between h-16 lg:h-21 rounded-full">
              <p className="text-xl leading-6 lg:text-[28px] lg:leading-8 font-medium">
                {tp.execute(t("paymentMethods.sbp"))}
              </p>
              <SBPIcon className="size-9" />
            </Box>
            <Box className="px-5 lg:px-6 flex items-center justify-between h-16 lg:h-21 rounded-full">
              <p className="text-xl leading-6 lg:text-[28px] lg:leading-8 font-medium">
                {tp.execute(t("paymentMethods.crypto"))}
              </p>
              <div className="flex items-center gap-1">
                <Box className="size-9 flex items-center justify-center">
                  <UsdtBrandIcon className="size-9" />
                </Box>
                <Box className="size-9 flex items-center justify-center">
                  <BtcBrandIcon className="size-9" />
                </Box>
                <Box className="size-9 flex items-center justify-center">
                  <EthBrandIcon className="size-9" />
                </Box>
              </div>
            </Box>
          </div>
        </div>
      </div>
      <div className="easy-to-use-background">
        <Image
          src="/images/easy_to_use-background.png"
          width={1263}
          height={842}
          alt="Easy To Use Background"
          className="easy-to-use-image"
          quality={100}
        />
      </div>
    </div>
  );
};
